import React from 'react';
import Link from 'redux-first-router-link';
import PropTypes from 'prop-types';

const BrandLogo = ({
  className,
  onClick,
  mark,
  footer,
}) => (
  <Link
    className={`brand-logo${className ? ` ${className}` : ''}`}
    to={{ type: 'LANDER' }}
    onClick={onClick}>
  { footer &&
  	<img className="brand-logo-img" src="https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-logo-white.svg" alt="PureWow logo" />
  }
  { (!footer && !mark) &&
  	<img className="brand-logo-img" src="https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-logo-black.svg" alt="PureWow mark" />
  }
  { (!footer && mark) &&
  	<img className="brand-mark-img" src="https://static.cdn.gallerymediagroup.com/purewow/logos/purewow-mark-black.svg" alt="PureWow logo" />
  }
  </Link>
);

BrandLogo.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default BrandLogo;
